import { configureStore } from "@reduxjs/toolkit";

import novelsReducer from "./novels";
import novelsChapsReducer from "./chaps";
import commentsReducer from "./comments";
import reportReducer from "./reports";
import userAuth from "./auth";
import userReducer from "./users";
export default configureStore({
  reducer: {
    novelsData: novelsReducer,
    novelsChaps: novelsChapsReducer,
    commentsData: commentsReducer,
    reportData: reportReducer,
    auth: userAuth,
    user: userReducer,
  },
});
